/** Backend capability strings for access-control admin surfaces. */
export const AccessControlPermissions = {
  read: 'manage_capabilities',
  manage: 'manage_capabilities',
  assignRoles: 'manage_roles',
  manageUsers: 'manage_users',
} as const
